<ng-container *transloco="let t; prefix: scope">
  <div>
    <p class="mb-6">{{ t('whatToDoWithCompany', { companyName }) }}</p>

    <bl-frontend-alert
      *ngIf="showMiniToAnnualClientInformation"
      class="block my-4"
      severity="info"
      [header]="'Mini blir Go eller Årskund - du väljer!'"
      content="Från 1 januari 2026 ändras Mini till 49 kr/mån.<br /><ul class='list-disc ml-6'><li>Välj Årskund för gratis bokföring i Lundify (passar årsvisa kunder)</li><li>Välj Go för samma pris som Mini (49 kr/mån), men med fler funktioner och nu även med e-postportal.</li></ul>"
      [useUnsafeHtml]="true"
      [dismissable]="false"></bl-frontend-alert>

    <bl-frontend-alert
      *ngIf="showMiniUpgradeInformation"
      class="block my-4"
      severity="info"
      [header]="'Uppgradera till Lundify Go - fler funktioner, samma pris'"
      content="Från 1 januari 2026 höjs priset för Mini till 49 kr/mån. Uppgradera till Go - samma pris, fler funktioner och nu även med e-postportal."
      [useUnsafeHtml]="true"
      [dismissable]="false"></bl-frontend-alert>

    <bl-frontend-radiobuttons
      name="action"
      [items]="radioButtonsItems"
      (valueChanged)="actionChanged($event)"></bl-frontend-radiobuttons>

    <!-- loading part -->
    <div class="flex flex-col mt-4" *ngIf="isLoadingSelected">
      @for (item of [1, 2, 3]; track item) {
        <div class="animate-pulse flex space-x-4">
          <div class="rounded-full bg-bl-grey-100 h-5 w-5"></div>
          <div class="flex-1 space-y-2 py-1">
            <div class="h-4 bg-bl-grey-100 rounded w-6/12"></div>
            <div class="h-3 bg-bl-grey-100 rounded"></div>
            <div class="h-3 bg-bl-grey-100 rounded w-8/12"></div>
          </div>
        </div>
      }
    </div>

    <!-- onboarding part -->
    <div class="flex flex-col mt-4" *ngIf="isOnboardSelected">
      <label class="font-bold block" for="email">{{ t('emailToCompany') }} *</label>
      <bl-frontend-email-input
        name="email"
        [placeholder]="t('email')"
        [ngModel]="email | async"
        (ngModelChange)="email.next($event)"></bl-frontend-email-input>
    </div>

    <!-- onboard as annual client part -->
    <div class="flex flex-col mt-4" *ngIf="isOnboardAsAnnualClientSelected">
      <label class="font-bold block" for="socialSecurityNumber">{{ t('yourSocialSecurityNumber') }} *</label>
      <bl-frontend-text-input
        name="socialSecurityNumber"
        [placeholder]="t('socialSecurityNumber')"
        [ngModel]="socialSecurityNumber | async"
        (ngModelChange)="socialSecurityNumber.next($event)"></bl-frontend-text-input>

      <p class="mt-4" [innerHTML]="t('firmUserWillBeAdminMessage') | safeHtml"></p>
    </div>

    <!-- archive company part -->
    <div class="flex flex-col mt-4" *ngIf="isArchivedSelected">
      <label class="font-bold block" for="years">{{ t('numberOfYearsToArchive') }} *</label>
      <p>{{ t('youCanSelectBeween') }}</p>
      <div class="flex items-center">
        <bl-frontend-tooltip [content]="t('numberOfYearsToArchive')">
          <!-- Change to this when numeric is updated to handle change on up and down arrows, 
           bug in updating the value now; @bl-components 5.3.0  -->

          <!-- <bl-frontend-numeric-input
            class="block w-36"
            name="years"
            [ngModel]="years | async"
            (ngModelChange)="years.next($event)"
            min="1"
            max="10"></bl-frontend-numeric-input> -->

          <input
            pInputText
            class="w-20"
            name="years"
            type="number"
            [ngModel]="years | async"
            (ngModelChange)="years.next($event)"
            min="1"
            max="10" />
        </bl-frontend-tooltip>
      </div>
      <div class="mt-4" *ngIf="existsInFirmSupport">
        <label class="font-bold block">{{ t('archiveInFirmSupport') }}</label>
        <bl-frontend-radiobuttons
          name="clientAction"
          [items]="clientActionRadioButtonsItems"
          (valueChanged)="clientActionChanged($event)"></bl-frontend-radiobuttons>
      </div>
      <div class="mt-4">
        <label class="font-bold block">{{ t('confirmArchive') }} *</label>
        <p-checkbox
          inputId="confirmArchive"
          [binary]="true"
          [label]="t('iUnderstandAndConfirmArchive')"
          [(ngModel)]="confirmArchive"></p-checkbox>
      </div>

      <div class="mt-4" *ngIf="showArchiveWarningIfRecentlyUsed">
        <bl-frontend-alert severity="warning" [content]="archiveWarningText" [useUnsafeHtml]="true"></bl-frontend-alert>
      </div>
    </div>

    <!-- unarchive company part -->
    <div class="flex flex-col mt-4" *ngIf="isUnarchiveSelected">
      <div class="mt-4">
        <label class="font-bold block" for="email">{{ t('yourSocialSecurityNumber') }} *</label>
        <bl-frontend-text-input
          name="socialSecurityNumber"
          [placeholder]="t('socialSecurityNumber')"
          [ngModel]="socialSecurityNumber | async"
          (ngModelChange)="socialSecurityNumber.next($event)" />

        <p class="my-4" [innerHTML]="t('firmUserWillBeAdminMessage') | safeHtml"></p>
        <label class="font-bold block">{{ t('confirmUnarchive') }} *</label>
        <p-checkbox
          inputId="confirmUnarchive"
          [binary]="true"
          [label]="t('iUnderstandAndConfirmUnarchive')"
          [(ngModel)]="confirmUnarchive"></p-checkbox>
      </div>
    </div>

    <!-- delete company part -->
    <div class="flex flex-col mt-4" *ngIf="isDeleteSelected">
      <div *ngIf="existsInFirmSupport">
        <label class="font-bold block">{{ t('doYouWantToArchiveOrDeleteInFirmSupport') }}</label>
        <bl-frontend-radiobuttons
          name="clientAction"
          [items]="clientActionRadioButtonsItems"
          (valueChanged)="clientActionChanged($event)"></bl-frontend-radiobuttons>
      </div>
      <div class="mt-4">
        <label class="font-bold block">{{ t('confirmDelete') }} *</label>
        <p-checkbox
          inputId="confirmDelete"
          [binary]="true"
          [label]="t('iUnderstandAndConfirmDelete')"
          [(ngModel)]="confirmDelete"></p-checkbox>
      </div>
    </div>
    <div class="flex justify-end mt-6">
      <bl-frontend-button
        class="mr-2"
        [text]="'shared.cancel' | transloco"
        variant="secondary"
        (onclick)="close(null)"></bl-frontend-button>
      <bl-frontend-button
        [text]="primaryButtonI18nKey | transloco"
        variant="primary"
        [disabled]="!isValid"
        (onclick)="next()"></bl-frontend-button>
    </div>
  </div>
</ng-container>
